import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { PaymentPolicy } from '../../components/PaymentPolicy'
import { useContext } from './Context'
import { EmptyCart } from './EmptyCart'
import { ManualShippingRateAlertPanel, CheckoutProvider, CheckoutBaseLayout } from '@ztechapps/order.webui'
import { getMyOrderQuery, isBelowMinimumOrderAmount as isBelowMinimum } from '@ztechapps/order.common'
import { Setting } from '../../config/settings'
import { routesDef } from '../../config/routes'
import { useStripeConfig } from '../../hooks/useStripeConfig'
import { DataSuspense, NullComponent } from '@ztechapps/webui.util'
import { CartItemPanel } from './CartItem/CartItemPanel'
import { ConfirmOrderButton } from './ConfirmOrderButton'
import { ContinueShoppingButton } from './ContinueShoppingButton'
import { useHistory } from '@ztechapps/common.hook'
import { EmailLink } from '../../components/EmailLink'
import { LoadingOverlay } from './LoadingOverlay'
import { Container } from 'react-bootstrap'
import { PageTitle } from '../../components/PageTitle'

export const CartContainer = () => {
  const history = useHistory()
  const { document, loading, showLoadingOverlay } = useContext()
  const appSettings = Setting.appSettings
  const customer = document?.by
  const orderId = document?._id

  const { success_url, cancel_url, createAchSourceUrl, paymentMethods } = useStripeConfig({ orderId })

  let shippingRatePanel = undefined
  if (document?.isManualShippingRate || document?.shipping?.shipmentId) shippingRatePanel = ManualShippingRateAlertPanel
  const canOrder = document?.allItemsInStockByOnHandAndComputedQuantity || document?.allowPrePayment
  const isBelowMinimumOrderAmount = isBelowMinimum(document)

  return (
    <React.Fragment>
      <PageTitle
        title="Shopping Cart"
        description="Review your shopping cart items, update quantities, and proceed to checkout"
      />
      <DataSuspense
        loading={loading || showLoadingOverlay}
        isEmpty={isEmpty(document?.items)}
        emptyComponent={<EmptyCart />}
        loadingComponent={<LoadingOverlay />}
      >
        <Container className="pb-5">
          <CheckoutProvider
            components={{
              itemPanel: CartItemPanel,
              confirmOrderButton: ConfirmOrderButton,
              cancelCheckoutButton: ContinueShoppingButton,
              shippingRatePanel,
              emailLink: EmailLink,
              manualShippingRate: NullComponent,
            }}
            {...{
              appSettings,
              customer,
              success_url,
              cancel_url,
              orderId: document?._id,
              orderQuery: getMyOrderQuery,
              onSuccess: async () => {
                //history.push(routesDef.)
                history.push(routesDef.AccountOrderItem.altPath({ _id: document?._id }))
              },
              createAchSourceUrl,
              paymentMethods,
              canOrder,
              isBelowMinimumOrderAmount,
              fromStore: true,
            }}
          >
            <CheckoutBaseLayout />
          </CheckoutProvider>
        </Container>
      </DataSuspense>

      <PaymentPolicy />
    </React.Fragment>
  )
}
